// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

// Model
import PayPlansModel from "@PayPlans/models/SalesAssociates";

export default function Layer() {
	return (
		<PayPlansFacade
			position={"Sales Associate"}
			defaultSections={["default", "miniDeal"]}
			cacheManagement={{
				clearAbsoluteIndexes: [
					"programDetails",
					"makes",
					"models",
					"modelYears",
					"payPlanCsiMetrics",
					"payPlansSidebarTree",
					"payPlanSalesPerformanceReportVersions",
					"salesPerformanceProducts",
				],
			}}
		>
			<PayPlansModel />
		</PayPlansFacade>
	);
}
